(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire637e"];
var parcelRegister = parcelRequire.register;
parcelRegister("3hMvC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2648968219c65597$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $2Aumc = parcelRequire("2Aumc");
var $2648968219c65597$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function CopyLink(param) {
        var el = param.el;
        (0, $J7ygF._)(this, CopyLink);
        this.el = el;
        this.init();
    }
    (0, $hvJJn._)(CopyLink, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.el.addEventListener("click", function() {
                    var text = _this.el.dataset.text && _this.el.dataset.text !== "" ? _this.el.dataset.text : window.location.href;
                    var successText = _this.el.dataset.successText && _this.el.dataset.successText !== "" ? _this.el.dataset.successText : "Link Copied";
                    if (text) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($2Aumc)))(text);
                        // get current innerHTML
                        var initialInnerHTML = _this.el.innerHTML;
                        _this.el.innerHTML = successText;
                        setTimeout(function() {
                            _this.el.innerHTML = initialInnerHTML;
                        }, 1500);
                    }
                });
            }
        }
    ]);
    return CopyLink;
}();

});
parcelRegister("2Aumc", function(module, exports) {
"use strict";

var $1cWNp = parcelRequire("1cWNp");
var $1e267dd9e9e5c6ae$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $1e267dd9e9e5c6ae$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $1e267dd9e9e5c6ae$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $1e267dd9e9e5c6ae$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $1cWNp();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var _$format = $1e267dd9e9e5c6ae$var$clipboardToIE11Formatting[options.format] || $1e267dd9e9e5c6ae$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(_$format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $1e267dd9e9e5c6ae$var$format("message" in options ? options.message : $1e267dd9e9e5c6ae$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $1e267dd9e9e5c6ae$var$copy;

});
parcelRegister("1cWNp", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});



})();
//# sourceMappingURL=CopyLink.8b282df0.js.map
